import { Link } from '@tanstack/react-router';
import { CalendarRange, Lock } from 'lucide-react';
import type { WholeFlatConflict } from '@/shared/api';
import { getOtaLabel } from '../OtaLogo';
import { conflictPeriod } from './flatFamilyModel';

/** Die Belegungen, an denen die Verknüpfung scheitert — ohne Gastdaten. */
export function WholeFlatConflictList({ conflicts }: { conflicts: WholeFlatConflict[] }) {
  return (
    <ul className="border-line divide-line/60 mt-3 divide-y rounded-md border">
      {conflicts.map((conflict) => (
        <li
          key={`${conflict.kind}-${conflict.propertyId}-${conflict.bookingId ?? conflict.from}`}
          className="flex min-w-0 items-start gap-3 px-3 py-2.5"
        >
          {conflict.kind === 'Booking' ? (
            <CalendarRange size={16} className="text-ink-soft mt-0.5 shrink-0" aria-hidden />
          ) : (
            <Lock size={16} className="text-ink-soft mt-0.5 shrink-0" aria-hidden />
          )}
          <span className="min-w-0 flex-1 text-sm">
            <span className="text-ink block font-medium">
              <ConflictTitle conflict={conflict} />
            </span>
            <span className="text-ink-soft block break-words">
              {conflict.propertyName} · {conflictPeriod(conflict)}
            </span>
          </span>
        </li>
      ))}
    </ul>
  );
}

function ConflictTitle({ conflict }: { conflict: WholeFlatConflict }) {
  if (conflict.kind === 'Block') return <>Sperre</>;
  const channel = conflict.channel ? getOtaLabel(conflict.channel) : null;
  const label = [`Buchung ${conflict.bookingReference ?? ''}`.trim(), channel]
    .filter(Boolean)
    .join(' · ');
  return conflict.bookingId ? (
    <Link
      to="/bookings/$id"
      params={{ id: conflict.bookingId }}
      className="focus-visible:ring-sage rounded-sm hover:underline focus-visible:outline-none focus-visible:ring-2"
    >
      {label}
    </Link>
  ) : (
    <>{label}</>
  );
}
